import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { vars } from '@/app/config/variables';

export class SwiperCarousel {
	containerSelector = '.js-swiper';
	prevSelector = '.js-swiper-prev';
	nextSelector = '.js-swiper-next';
	paginationSelector = '.js-swiper-pagination';
	scrollbarSelector = '.js-swiper-scrollbar';
	pageContainerSelector = '.template-page__container';

	constructor(container, breakpoints) {
		this.container = container;
		if (!this.container) return;

		this.breakpoints = breakpoints || this.defaultBreakpoints;

		this.init();
	}

	init() {
		this.parent = this.container.parentElement;
		this.pageContainer = document.querySelector(this.pageContainerSelector);
		this.mq = window.matchMedia(`(min-width: ${vars.breakpoint.tablet}px)`);

		this.initSwiper();
		this.initObserver();
		this.bindEvents();
		this.handleMQChange(this.mq);
	}

	initSwiper() {
		this.swiper = new Swiper(this.container, {
			modules: [Navigation, Pagination, Scrollbar],
			slidesPerView: 'auto',
			slidesOffsetBefore: app.getContainerPadding(),
			slidesOffsetAfter: app.getContainerPadding(),
			spaceBetween: 8,
			navigation: {
				prevEl: this.parent.querySelector(this.prevSelector),
				nextEl: this.parent.querySelector(this.nextSelector),
			},
			pagination: {
				el: this.parent.querySelector(this.paginationSelector),
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 1,
			},
			scrollbar: {
				el: this.parent.querySelector(this.scrollbarSelector),
				hide: false,
				draggable: true,
			},
			breakpoints: this.breakpoints,
		});
	}

	initObserver() {
		if (!this.pageContainer) return;

		this.observer = new ResizeObserver(() => {
			app.recalcSwiperOffsets(this.swiper);
		});
	}

	connectObserver() {
		if (!this.observer || !this.pageContainer || this.isObserving) return;

		this.observer.observe(this.pageContainer);
		this.isObserving = true;
	}

	disconnectObserver() {
		if (!this.observer || !this.isObserving) return;

		this.observer.disconnect();
		this.isObserving = false;
	}

	handleMQChange = ({ matches }) => {
		if (matches) {
			this.disconnectObserver();

			this.swiper.params.slidesOffsetBefore = 0;
			this.swiper.params.slidesOffsetAfter = 0;
			this.swiper.update();
		} else {
			this.connectObserver();
			app.recalcSwiperOffsets(this.swiper);
		}
	};

	bindEvents() {
		this.mq.addEventListener('change', this.handleMQChange);
	}

	defaultBreakpoints = {
		[vars.breakpoint.tablet]: {
			slidesPerView: 3,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			spaceBetween: 8,
		},
		[vars.breakpoint.laptop]: {
			slidesPerView: 5,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			spaceBetween: 16,
		},
	};
}
